import './HStoryTop.scss';

import * as tsx from 'vue-tsx-support';
import { PropType } from 'vue';
import { HIconLink } from '~/components/HIcon';
import { AvailableLanguage, StoryModule } from '~/schemes';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';

export const HStoryTop = tsx.component({
  name: 'HStoryTop',
  functional: true,
  props: {
    story: {
      type: Object as PropType<
        ResolvedLanugageData<
          StoryModule['properties']['stories'][number],
          AvailableLanguage
        >
      >,
      required: true,
    },
  },
  render(h, { props, parent }) {
    const { story } = props;
    return (
      <div staticClass="h-story-top">
        {story.description && (
          <div
            staticClass="h-story-top__description"
            v-wysiwyg={story.description}></div>
        )}

        {story.link && story.link.url && (
          <HIconLink
            staticClass="h-story-top__detail"
            icon="arrow-right"
            props={{
              ...parent.$navigation.resolveHrefTo(story.link.url),
            }}
            hiddenExternalIcon>
            {story.link.text || parent.$t('label.details')}
          </HIconLink>
        )}

        {story.image && (
          <img
            staticClass="h-story-top__image"
            src={story.image.derived.main.url}
            alt=""
          />
        )}
      </div>
    );
  },
});
